import { Text } from '@trmediaab/zebra';
import { CheckCircle } from '@trmediaab/zebra-icons';

import TextWithAdjacentIcon from '../TextWithAdjacentIcon';
import Card from '.';

interface InfoCardProps {
  title: string;
  body: React.ReactNode;
}

const InfoCard = ({ title, body }: InfoCardProps) => (
  <Card>
    <TextWithAdjacentIcon
      icon={<CheckCircle size="16px" color="checkout.icon1" />}
      text={title}
      lineHeight="medium"
      fontWeight="bold"
    />
    <Text mt="1,5">{body}</Text>
  </Card>
);

export default InfoCard;
